module.exports = __webpack_public_path__ + "img/created-by-jobmule.b18cffee.png";